import * as React from 'react';
import * as classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { AudienceRule as IAudienceRule } from '@nexxt/common/types';
import Slider from '../../../common/Slider';
import HealthIcon from '../../../common/designElements/HealthIcon';
interface AudienceRuleHeaderProps {
    audienceRule: IAudienceRule;
    toggle?: boolean;
    quotaEnabled: boolean;
    isDisabled: boolean;
    isMenuOpen: boolean;
    isBuiltIn: boolean;
    isHalfWidth: boolean;
    hasInvalid?: boolean;
    errorObject?: any;
    health?: any;
    setIsMenuOpen: () => void;
    onEdit: (editingQuestion) => void;
    onDelete: () => void;
    onChangeFilterToggle?: (value) => void;
    disableByFieldName: (keyName?: string) => boolean;
}
const AudienceRuleHeader = (props: AudienceRuleHeaderProps): JSX.Element => {
    const friendlyAudienceName = props.isBuiltIn
        ? 'targeting options'
        : 'custom screeners';

    return (
        <>
            <div className="audience--screeners--card--header">
                <div
                    className={`header-title ${
                        !props.isHalfWidth ? 'full-size' : 'half-size'
                    }`}
                >
                    <HealthIcon
                        questionID={
                            props.audienceRule.selectedQuestion.questionId
                        }
                        active={!!props.health}
                        type={props.health?.type}
                        className={`health ${props.health?.type?.toLowerCase()}`}
                        message={props.health && props.health.list[0].message}
                    />
                    <span>{props.audienceRule.selectedQuestion.label}</span>
                </div>
                <div className="right-side">
                    {props.quotaEnabled && (
                        <>
                            <Slider
                                onChange={props.onChangeFilterToggle}
                                checked={props.toggle}
                                disabled={props.isDisabled}
                            />
                            <span>Custom Quota</span>
                        </>
                    )}
                    <>
                        <span
                            className="audience--button"
                            onClick={() =>
                                props.onEdit(
                                    props.audienceRule.selectedQuestion
                                )
                            }
                            data-for={`${props.audienceRule?.selectedQuestion?.value}-edit-tooltip`}
                            data-tip="custom show"
                        >
                            <i className="nx nx-edit" />
                        </span>
                        <ReactTooltip
                            id={`${props.audienceRule?.selectedQuestion?.value}-edit-tooltip`}
                            aria-haspopup="true"
                            effect="solid"
                            place="top"
                        >
                            <span>Edit {friendlyAudienceName}</span>
                        </ReactTooltip>
                    </>
                    <>
                        <span
                            className="audience--button"
                            onClick={() => props.onDelete()}
                            data-for={`${props.audienceRule?.selectedQuestion?.value}-delete-tooltip`}
                            data-tip="custom show"
                        >
                            <i className="nx nx-delete" />
                        </span>
                        <ReactTooltip
                            id={`${props.audienceRule?.selectedQuestion?.value}-delete-tooltip`}
                            aria-haspopup="true"
                            effect="solid"
                            place="top"
                        >
                            <span>Delete {friendlyAudienceName}</span>
                        </ReactTooltip>
                    </>
                </div>
            </div>
        </>
    );
};

export default AudienceRuleHeader;
